/* globals window */
import { React, PT, WithData, withRouter } from '@gasbuddy/react';
import { Dimmer, Loader, Table, Segment, Form, Button, Icon, Grid, Header, Message } from 'semantic-ui-react';
import moment from 'moment';
import { fetchApi } from '@gasbuddy/react/build/fetchApi';
import JSONTree from 'react-json-tree';
import { Auth, Nav, ActionTable, NoteTable } from '../../components';
import { Role } from '../../roles';
import EditLinkDialog from '../../components/loyalty/EditLinkDialog';
import { rewardValue } from './util';
import { OfferDetail } from './OfferDetail';
import style from './style.css';
import { StatsModal } from './StatsModal';

class BaseOffer extends React.Component {
  state = {
  }

  saveLink = ({ template }) => {
    const { data: { details }, fetch } = this.props;
    const { link } = this.state;
    this.setState({ modal: null, saving: true }, async () => {
      await fetchApi({
        url: `/loyalty/offers/${details.offer_id}/link`,
        body: {
          template,
          path: link.path,
        },
      });
      this.setState({ saving: false }, () => fetch());
    });
  }

  editExtraData = (e) => {
    e.preventDefault();
    this.setState({ editExtra: true });
  }

  updateFromContentful = (e) => {
    const { data: { details, links }, fetch } = this.props;
    const link = links.find(l => l.is_default) || links[0];
    e.preventDefault();
    this.setState({ modal: null, saving: true }, async () => {
      const { error } = await fetchApi({
        url: `/loyalty/offers/${details.offer_id}/sync`,
        body: {
          path: link.path,
        },
        httpResponseErrors: true,
        catchErrors: true,
      });
      this.setState({ saving: false, error }, () => fetch());
    });
  }

  save() {
    const { data: { details: { offer_id: cid } }, fetch } = this.props;
    // eslint-disable-next-line babel/camelcase
    const { extra_data } = this.state;
    this.setState({ saving: true }, async () => {
      const { error } = await fetchApi({
        url: `/loyalty/offers/${cid}/update`,
        body: {
          extra_data,
        },
        httpResponseErrors: true,
        catchErrors: true,
      });
      this.setState({ saving: false, error }, () => fetch());
    });
  }

  toggleActive() {
    const { data: { details }, fetch } = this.props;
    this.setState({ saving: true }, async () => {
      const { error } = await fetchApi({
        url: `/loyalty/campaigns/${details.campaign_id}/active`,
        body: {
          active: !!details.deleted_at,
        },
        httpResponseErrors: true,
        catchErrors: true,
      });
      this.setState({ saving: false, error }, () => fetch());
    });
  }

  testLink(path) {
    const { data: { userGuid } } = this.props;
    window.open(`https://iam.gasbuddy.com/campaign-link?u=${userGuid}&c=${path}`, 'testCampaignLink');
  }

  fieldChangeHandler(field) {
    return ({ target: { value } }) => {
      const { data: { details } } = this.props;
      this.setState({ [field]: details?.[field] === value ? null : value });
    };
  }

  hasChanges() {
    return ['item_description', 'fine_print', 'instructions', 'details', 'extra_data', 'image_url']
      // eslint-disable-next-line react/destructuring-assignment
      .filter(field => (this.state[field] !== null && this.state[field] !== undefined)).length > 0;
  }

  render() {
    const { loading, data, fetch } = this.props;
    const { saving, modal, link, extra_data: stateEd, error, editExtra } = this.state;
    const { details, links, actions, notes } = data || {};
    return (
      <Auth forRoles={[Role.Superuser, Role.GasBackCampaigns]}>
        <Nav>

          {modal === 'editLink' && (
            <EditLinkDialog defaultValue={link} onSubmit={this.saveLink} onCancel={() => this.setState({ modal: null })} />
          )}

          <Form onKeyPress={(e) => {
            if (e.target.type !== 'textarea' && e.which === 13 /* Enter */) {
              e.preventDefault();
            }
          }}
          >
            <Grid>
              <Grid.Row>
                <Grid.Column width={10}>
                  <h1>{details ?.partner_name || 'Campaign'}</h1>
                </Grid.Column>
                <Grid.Column textAlign="right" width={6}>
                  {details && <StatsModal offer={details} />}
                  <Button icon onClick={fetch}>
                    <Icon name="refresh" />
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>

            {details?.deleted_at && (
              <Message negative>
                This campaign was made inactive on
                {` ${moment(details.deleted_at).toLocaleString()}`}
              </Message>
            )}
            {error && (
              <Message negative>
                <Message.Header>Oops - Changes Failed</Message.Header>
                <pre>{`${error.message}\n${error.stack}`}</pre>
              </Message>
            )}
            <Dimmer.Dimmable as={Segment} dimmed={loading || saving}>
              <Dimmer active={loading || saving}>
                <Loader />
              </Dimmer>
              <Grid>
                <Grid.Row stretched>
                  <Grid.Column width={10}>
                    <Table basic="very" collapsing>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell>Created:</Table.Cell>
                          <Table.Cell>{moment(details?.created_at).toLocaleString()}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>Display After:</Table.Cell>
                          <Table.Cell>{moment(details?.display_after).toLocaleString()}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>Display Until:</Table.Cell>
                          <Table.Cell>{details?.display_before ? moment(details.display_before).toLocaleString() : '-'}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>Reward:</Table.Cell>
                          <Table.Cell>{rewardValue(details)}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>Boost Factor:</Table.Cell>
                          <Table.Cell>{details?.boost_factor}</Table.Cell>
                        </Table.Row>
                        {details?.response_delay && (
                          <Table.Row>
                            <Table.Cell>Response Delay:</Table.Cell>
                            <Table.Cell>{details?.response_delay}</Table.Cell>
                          </Table.Row>
                        )}
                        {details?.usage_limit && (
                          <Table.Row>
                            <Table.Cell>Usage Limit:</Table.Cell>
                            <Table.Cell>{details?.usage_limit}</Table.Cell>
                          </Table.Row>
                        )}
                      </Table.Body>
                    </Table>

                    <Header as="h3" block attached="top" style={{ flex: 0 }}>
                      Links
                    </Header>
                    <Segment attached>
                      <Table basic="very" style={{ tableLayout: 'fixed' }}>
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell width={1}>Id</Table.HeaderCell>
                            <Table.HeaderCell>Path</Table.HeaderCell>
                            <Table.HeaderCell>Template</Table.HeaderCell>
                            <Table.HeaderCell textAlign="right" width={4}>Actions</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          {(links || []).map(l => (
                            <Table.Row key={l.link_id}>
                              <Table.Cell>{l.link_id}</Table.Cell>
                              <Table.Cell>{l.path}</Table.Cell>
                              <Table.Cell style={{ overflow: 'scroll', textOverflow: 'ellipsis' }}>{l.template}</Table.Cell>
                              <Table.Cell textAlign="right">
                                &nbsp;
                                <Button size="mini" onClick={(e) => { e.preventDefault(); this.testLink(l.path); }}>Test</Button>
                                &nbsp;
                                <Button size="mini" onClick={(e) => { e.preventDefault(); this.setState({ modal: 'editLink', link: l }); }}>Edit</Button>
                              </Table.Cell>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    </Segment>

                    <Header as="h3" block attached="top" style={{ flex: 0 }}>
                      <Button floated="right" size="mini" onClick={this.editExtraData}>Edit</Button>
                      Extra Data
                    </Header>
                    <Segment attached>
                      {editExtra ? (
                        <Form.TextArea
                          onChange={this.fieldChangeHandler('extra_data')}
                          value={stateEd || JSON.stringify(details?.extra_data, null, '  ')}
                          rows={6}
                        />
                      ) : <JSONTree data={details?.extra_data} />}
                    </Segment>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <Message style={{ flex: 0, minHeight: 160, textAlign: 'center' }}>
                      <Message.Content>
                        <p>
                          The information below (detail, images, title, as well as display
                          dates and tags shown on the left) must be edited
                          in Contentful. See @laurenm or @keith for login information. Reward
                          parameters and other information cannot be edited, and typically
                          a new offer should be created with a new link.
                        </p>
                        <div>
                          <Button size="small" onClick={() => window.open('https://app.contentful.com/spaces/krty9z4e17dj/entries?contentTypeId=gasBackOffers&order.fieldId=bLMHa9LyG4Yi996m&order.direction=ascending', 'contentful')}>Open Contentful</Button>
                          <Button size="small" onClick={this.updateFromContentful}>Push Contentful Live</Button>
                        </div>
                      </Message.Content>
                    </Message>
                    <div style={{ margin: 'auto' }}>
                      <div className="marvel-device iphone-x">
                        <div className="top-bar" />
                        <div className="sleep" />
                        <div className="bottom-bar" />
                        <div className="volume" />
                        <div className="overflow">
                          <div className="shadow shadow--tr" />
                          <div className="shadow shadow--tl" />
                          <div className="shadow shadow--br" />
                          <div className="shadow shadow--bl" />
                        </div>
                        <div className="inner-shadow" />
                        <div className={`screen ${style.screen}`}>
                          {data?.clientOffer && <OfferDetail offer={data.clientOffer} />}
                        </div>
                      </div>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>

              <Grid columns="equal">
                <Grid.Row>
                  <Grid.Column>
                    <Header as="h3" block attached="top" style={{ flex: 0 }}>
                      Audit Log
                    </Header>
                    <Segment attached>
                      <ActionTable actions={actions} />
                    </Segment>
                  </Grid.Column>
                  <Grid.Column>
                    <NoteTable notes={notes} type="gasback-campaign" id={Number(details ?.campaign_id || 0)} />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Dimmer.Dimmable>
          </Form>
        </Nav>
      </Auth>
    );
  }
}

BaseOffer.propTypes = {
  data: PT.shape({
    details: PT.shape({
      name: PT.string,
    }),
    links: PT.arrayOf(PT.shape({

    })),
  }),
  fetch: PT.func,
  loading: PT.bool,
};

BaseOffer.defaultProps = { loading: true, data: null, fetch() {} };

export default withRouter(({ match }) => (
  <WithData url={`/loyalty/offers/${match.params.offerId}/details`}>
    <BaseOffer
      offerId={Number(match.params.offerId)}
    />
  </WithData>
));
